import { render, staticRenderFns } from "./CalvingDetails.vue?vue&type=template&id=36d7dde5&scoped=true&"
import script from "./CalvingDetails.vue?vue&type=script&lang=js&"
export * from "./CalvingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d7dde5",
  null
  
)

export default component.exports